import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ControlErrorsDirective } from 'src/app/shared/directives/control-error.directive';
import { ControlErrorComponent } from '../control-error.component';
import { ControlErrorContainerDirective } from 'src/app/shared/directives/control-error-container.directive';
import { FormSubmitDirective } from 'src/app/shared/directives/form-submit.directive';

@NgModule({
  declarations: [
    ControlErrorsDirective,
    ControlErrorComponent,
    ControlErrorContainerDirective,
    FormSubmitDirective
  ],
  imports: [
    CommonModule
  ],
  exports: [
    ControlErrorsDirective,
    FormSubmitDirective,
    ControlErrorContainerDirective,
  ]
})
export class ShowControlErrorsModule { }
